import { createContext, useCallback, useContext, useState } from 'react'

import { v4 as uuidv4 } from 'uuid'

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper NotificationContext type
const NotificationContext = createContext([] as any[])

type Level = 'success' | 'warning' | 'error'

export interface INotification {
  uid: string
  message: string
  level: Level
  sent: boolean
  actionLabel?: string
  onAction?: () => void
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper children type
export const NotificationsProvider = ({ children }: any) => {
  const [notifications, setNotifications] = useState<INotification[]>([])

  return (
    <NotificationContext.Provider value={[notifications, setNotifications]}>
      {children}
    </NotificationContext.Provider>
  )
}

export const useNotifications = () => {
  const [notifications, setNotifications] = useContext(NotificationContext)

  const addNotification = useCallback(
    (
      message: string,
      level: Level,
      options?: { actionLabel?: string; onAction?: () => void },
    ) => {
      const newNotification: INotification = {
        uid: uuidv4(),
        message,
        level,
        sent: false,
        actionLabel: options?.actionLabel,
        onAction: options?.onAction,
      }

      setNotifications((prevNotifications: INotification[]) => {
        return [...prevNotifications, newNotification]
      })
    },
    [setNotifications],
  )

  return {
    notifications: notifications as INotification[],
    setNotifications,
    addNotification,
  }
}
